import {action} from 'easy-peasy';
export default {
  setName: action((state, payload) => {
    state.name = payload;
  }),
  setSkillId: action((state, payload) => {
    state.skilllid = payload;
  }),
  setIsOnline: action((state, payload) => {
    state.IsOnline = payload || false;
  }),
  setOpen: action((state, payload) => {
    state.open = payload || false;
  }),
  setSelectedGender: action((state, payload) => {
    state.selectedGender = payload || null;
  }),
  setSortBy: action((state, payload) => {
    state.SortBy = payload || null;
  }),
  setOnlyHomeCare: action((state, payload) => {
    state.OnlyHomeCare = payload || null;
  }),
  setCategory: action((state, payload) => {
    state.category = payload || 'ALL';
  }),
  setShowItems: action((state, payload) => {
    console.log({payload});
    state.showItems = payload || true;
  }),
};
